export default "/images/2ac25ff3c068b7b97e187bd05bbf0fe2.jpg";